import type { CampaignDetailsCreator } from '@metapic-apps/shared'

import type { CampaignDetailsCreatorRaw } from '@/lib/types/campaign-creators.types'

export const normalizeCampaignCreatorsList = (
  creators: CampaignDetailsCreatorRaw[],
): CampaignDetailsCreator[] =>
  creators.map((creator) => ({
    id: creator.id,
    userId: creator.userId,
    displayName: creator.displayName,
    linksCount: creator.linksCreated,
    contentCount: creator.contentCreated,
    clicksCount: creator.clicks,
    gpRatio: creator.estimatedEarningToCostRatio,
    estimatedGp: creator.estimatedGp / 100,
    estimatedMediaValue: parseFloat(creator.estimatedMediaValue?.amount ?? '0'),
    invitePending: creator.status === 'open',
    ...(creator.creatorAvatar?.key && {
      avatar: {
        key: creator.creatorAvatar.key,
        baseUrl: creator.creatorAvatar.baseUrl ?? '',
        url: creator.creatorAvatar.url,
      },
    }),
    overrides: {
      clickLimit: creator.overrides?.clickLimit ?? null,
      trafficSourcesCosts: [],
    },
  }))
